// Fire-and-forget behavior beacon — allowlisted names only (see server
// eventsRoutes). Never blocks UX; failures are silent by design.
import { authFetch, apiUrl } from "./api";
export function trackEvent(name, meta = {}, surface = "ollie") {
  try {
    authFetch(apiUrl("/api/events"), {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ name, surface, meta }),
    }).catch(() => {});
  } catch (_) { /* never throw from telemetry */ }
}
